<template>
  <div>
    <v-flex xs12 class="text-center mt-3">
      <v-btn flat small @click="previous">Forrige</v-btn>
      <v-btn large color="primary" @click="next">Neste</v-btn>
    </v-flex>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Object,
      default: null
    }
  },
  methods: {
    next: function() {
      if(this.step) {
        if(!this.step.finished) {
          return false
        }
      }
      this.$emit("next-page");
    },
    previous: function() {
      if(this.step) {
        if(!this.step.finished) {
          this.step.setNotFinished()
        }
      }
      this.$emit("previous-page");
    }
  }
};
</script>